$('.custom-size label, .custom-denominations label').click(function(){
    // console.log($(this).attr('data-img-position'))
    $('.slider-for').slick('slickGoTo', $(this).attr('data-img-position'))
    // $('.slider-nav').slick('slickGoTo', $(this).attr('data-img-position'))
})

$('.countrySelector_item').on('click', function(e) {
    e.preventDefault(); // Prevent the default link behavior
    var targetUrl = $(this).attr('href'); // Get the href attribute
    
    if (targetUrl) {
        window.location.href = targetUrl; // Redirect to the URL
    }
});

const disableLocalizationModal = () => {
  if(document.querySelector('.clm-outer-cont')){
    document.querySelector('.clm-outer-cont').style.display = 'none'
  }
}
const enableLocalizationModal = () => {
  if(document.querySelector('.clm-outer-cont')){
    document.querySelector('.clm-outer-cont').style.display = 'block'
  }
}

if(document.querySelector('.clm-form')){
  document.querySelectorAll('.clm-form').forEach((item) => {
    item.addEventListener('change', () => {
      let itemName = item.getAttribute('name')
      // if(itemName == 'countrySelector'){
      //   console.log(`country selector ${itemName}`)
      //   document.querySelector('.clm-cont input[name="country_code"]').value = document.querySelector('select[name="countrySelector"]').value
      // }
      // else 
      if(itemName = 'languageSelector'){
        console.log(`language selector ${itemName}`)
        document.querySelector('.clm-cont input[name="language_code"]').value = document.querySelector('select[name="languageSelector"]').value;
        if(document.querySelector('select[name="languageSelector"]').value == 'cs'){
          document.querySelector('.clm-cont input[name="country_code"]').value = 'CZ'
        }
        else if(document.querySelector('select[name="languageSelector"]').value == 'sk'){
          document.querySelector('.clm-cont input[name="country_code"]').value = 'SK'
        }
      }
      else{
        console.log(`itemName - ${itemName} is not present`)
      }
    })
  })
}

const cartUpdate = () => {
  fetch("https://dogmama.cz/?section_id=cart-drawer")
    .then((response) => response.text())
    .then((responseText) => {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
    for (const selector of selectors) {
      const targetElement = document.querySelector(selector);
      const sourceElement = html.querySelector(selector);
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }
    }
    })
    .catch((e) => {
    console.error(e);
    });
}

const upsellAtc = (event, varid, qnt) => {
  // Prevent the default form submission behavior
  if (event) {
    event.preventDefault();
  }

  document.querySelector(`.cu-item[data-varid="${varid}"] .cu-atc-svg`).classList.add('hidden')
  document.querySelector(`.cu-item[data-varid="${varid}"] .cu-atc-loading`).classList.remove('hidden')

  let formData = {
    'items': [{
      'id': varid,
      'quantity': qnt
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    console.log('upsell product added', data);
    cartUpdate();
    document.querySelector(`.cu-item[data-varid="${varid}"] .cu-atc-svg`).classList.remove('hidden')
    document.querySelector(`.cu-item[data-varid="${varid}"] .cu-atc-loading`).classList.add('hidden')
  })
  .catch((error) => {
    console.error('Error:', error);
    document.querySelector(`.cu-item[data-varid="${varid}"] .cu-atc-svg`).classList.remove('hidden')
    document.querySelector(`.cu-item[data-varid="${varid}"] .cu-atc-loading`).classList.add('hidden')
  });
}

// Fix for cart drawer showing blank after returning from checkout (bfcache issue)
window.addEventListener('pageshow', function(event) {
  if (event.persisted || (window.performance && window.performance.getEntriesByType('navigation')[0]?.type === 'back_forward')) {
    // Page was restored from bfcache - refresh cart UI
    refreshCartUI();
  }
});

async function refreshCartUI() {
  try {
    // Fetch fresh cart data
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    // Update cart count bubble
    const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
    cartCountBubbles.forEach(bubble => {
      const countElement = bubble.querySelector('span[aria-hidden="true"]');
      if (countElement) {
        countElement.textContent = cart.item_count;
      }
      bubble.style.display = cart.item_count > 0 ? '' : 'none';
    });

    // Update cart drawer using Section Rendering API
    const sectionsResponse = await fetch(`${window.routes?.cart_url || '/cart'}?sections=cart-drawer,cart-icon-bubble`);
    const sections = await sectionsResponse.json();

    // Update cart drawer
    if (sections['cart-drawer']) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        const newCartDrawer = html.querySelector('cart-drawer');
        if (newCartDrawer) {
          cartDrawer.innerHTML = newCartDrawer.innerHTML;
          // Update empty state class
          if (cart.item_count === 0) {
            cartDrawer.classList.add('is-empty');
          } else {
            cartDrawer.classList.remove('is-empty');
          }
        }
      }
    }

    // Update cart icon bubble
    if (sections['cart-icon-bubble']) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = html.getElementById('cart-icon-bubble');
        if (newBubble) {
          cartIconBubble.innerHTML = newBubble.innerHTML;
        }
      }
    }

    console.log('Cart UI refreshed after navigation');
  } catch (error) {
    console.error('Error refreshing cart:', error);
  }
}